// extracted by mini-css-extract-plugin
export default {"spacer":"Tooltip_spacer__PPzH8","baseline":"Tooltip_baseline__CNtEk","latest":"Tooltip_latest__XVC+g","noWrap":"Tooltip_noWrap__folHG"};